import { getBaseThemeName, getTheme } from "@/features/branding";
import { facadesApi } from "@/store/services/facades";
import { FacadesBatchPostRequest, FacadesBatchPostResponse } from "@/store/services/facades/types";
import { HaloRequest, HaloResponse, RawHaloResponse } from "@/store/services/facades/types/halo";
import { GEOCODING_ERRORS_FROM_API } from "@/utils/geocoding";

const PROJECT_HALO_HEADERS = {
  Authorization: `Basic ${process.env.NEXT_PUBLIC_FACADES_ABCDE_API_KEY}`,
};

export const haloFacadesApi = facadesApi.injectEndpoints({
  endpoints: (build) => ({
    getHaloRiskBands: build.query<HaloResponse, HaloRequest>({
      query: (body) => {
        return {
          method: "POST",
          url: "project_halo",
          headers: PROJECT_HALO_HEADERS,
          body,
        };
      },
      transformErrorResponse: (error) => {
        const errorData = error.data as {
          title: string;
          status: number;
          detail: string;
          type: string;
        };

        const detail =
          errorData.detail === "Try adding more details to the address and try again"
            ? "Specify addresses in accordance with the format used by Hongkong Post. Additional address elements such as business names and unit, suite or floor numbers should be avoided."
            : errorData.detail;

        let errorMessage = "Something unexpected happened. Please try again.";
        const isGeocodingError = GEOCODING_ERRORS_FROM_API.find((err) => errorData.title === err);
        if (isGeocodingError) {
          errorMessage = `The system was unable to geocode this entry using the information provided. Please supply more detailed address information or, for the most accurate results, provide latitude and longitude coordinates.  For further guidance, please refer 
                    [${
                      getBaseThemeName() === "hkma" ? `this geocode passthrough document` : `to this article`
                    }](${getTheme().meta.config.geocoding.guidelineDocumentUrl})`;
        } else if (errorData.title && detail) {
          errorMessage = `${errorData.title}. ${detail}.`;
        }

        return {
          message: errorMessage,
          status: errorData.status,
        };
      },
      transformResponse: (response: RawHaloResponse): HaloResponse => {
        return {
          mode: "halo",
          ...response,
        };
      },
    }),

    postHaloBatch: build.query<FacadesBatchPostResponse, FacadesBatchPostRequest>({
      query: ({ priority, batch }) => {
        return {
          method: "POST",
          url: "project_halo/batch",
          headers: {
            ...PROJECT_HALO_HEADERS,
            "Content-Type": "application/x-ndjson",
          },
          params: { priority },
          body: batch.join("\n"),
        };
      },
      extraOptions: {
        maxRetries: 0,
      },
    }),
  }),
});
